module.exports = __webpack_public_path__ + "static/media/smart-card.3fbef871.png";